/**
 * 短信发送
 */
import request from '@/utils/request'
export function sendSms(phone) {
  return request({
    url:'/sms/sendSms',
    method:'post',
    params:{phone:phone}
  })
}

export function verifySms(phone,code) {
  return request({
    url:'/sms/verifySms',
    method:'get',
    params:{phone:phone,phoneCode:code}
  })
}



// WEBPACK FOOTER //
// ./src/api/sms.js